// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3VMNo","content":"LayoutSettings_content__2UMCu"};